import React from 'react'
import { useTranslation } from 'react-i18next'
import { clsx } from '../../../utils/helper'

import ButtonRound from '../../elements/button-round'
import FormatCurrency from '../../elements/FormatCurrency'
import GroupAmount from '../../elements/group-amount'

const InCartItem = ({ handleUpdateAmount, food, handleEditFood }) => {
    const { beilageMapped, currentAmount, total, editable } = food

    const { t } = useTranslation()

    return (
        <div className={clsx(['in-cart-item', !editable && 'submitted'])}>
            <div className="content">
                <div className="beilage">
                    {!!food.foodParent && <div className="name">{food.name}</div>}
                    {beilageMapped?.length
                        ? beilageMapped.map((bei, index) => (
                              <div key={index} className="beilage-added__item">
                                  <i>{bei.name_food}</i>
                              </div>
                          ))
                        : t('modalFastEditMobile.lbDefault')}
                </div>
                <div className="price">
                    <b>
                        <FormatCurrency amount={total} />
                    </b>
                </div>
            </div>

            {editable && (
                <div className="actions">
                    <ButtonRound
                        secondary
                        className="mr-auto"
                        onClick={handleEditFood}
                    >
                        <i className="fas fa-pen mr-2" />
                        {t('modalFastEditMobile.btnChange')}
                    </ButtonRound>
                    <GroupAmount
                        handleDecrease={() =>
                            handleUpdateAmount(
                                -1,
                                food.indexInCart,
                                food.id,
                                food.groupOrder
                            )
                        }
                        handleIncrease={() =>
                            handleUpdateAmount(
                                1,
                                food.indexInCart,
                                food.id,
                                food.groupOrder
                            )
                        }
                        currentValue={currentAmount}
                    />
                </div>
            )}
        </div>
    )
}

export default InCartItem
